import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './DiscountSurchargesDisplayComponent.metadata.json5';
import './DiscountSurchargesDisplayComponent.messages';

const getCell = (items, index, property) => {
    return !_.isObject(items[property.id]) ? items[property.id] : null;
};

export function DiscountSurchargesDisplayComponent({ data }) {
    const overrides = {
        discountSurchargeTable: {
            data: data
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            getCell: getCell
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={data}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

DiscountSurchargesDisplayComponent.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({}))
};

DiscountSurchargesDisplayComponent.defaultProps = {
    data: []
};

export default DiscountSurchargesDisplayComponent;
